import request from '../utils/request';
import qs from "qs";
//蜗牛充值支付
export const woniuPay = param => {
	return request.post('/api/topUp/pay', param, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
};

//导出
export const download = param => {
	return request.post('/api/topUp/download', qs.stringify(param), {
		responseType: 'blob'
	})
};
//迪迦用户信息查询
export const dxtQuery = param => {
	return request.post('/api/dxt/query', qs.stringify(param))
};
//迪迦用户信息查询
export const dxtbatchQuery = param => {
	return request.post('/api/dxt/batchQuery', qs.stringify(param))
};
//迪迦用户信息批量查询
export const batchQueryRecord = param => {
	return request.post('/api/dxt/batchQueryRecord', qs.stringify(param))
};
//迪迦停复机记录
export const stopOrOpenRecord = param => {
	return request.post('/api/dxt/stopOrOpenRecord', qs.stringify(param))
};
//迪迦预约审核列表
export const ShipmentList = param => {
	return request.post('/api/dxt/ShipmentList', qs.stringify(param))
};

//迪迦预约导出
export const reviewInfo = param => {
	return request.post('/api/dxt/review-info', qs.stringify(param))
};
//迪迦预约导入
export const importShipmentInfo = param => {
	return request.post('/api/dxt/import-shipment-info', qs.stringify(param))
};
//迪迦预约快递详情
export const logisticsInfo = param => {
	return request.post('/api/dxt/logistics-info', qs.stringify(param))
};
//迪迦预约快递详情
export const clearLogisticsInfo = param => {
	return request.post('/api/dxt/clear-logistics-info', qs.stringify(param))
};
//长城停复机记录
export const stopOrOpenRecordcc = param => {
	return request.post('/api/cc/stopOrOpenRecord', qs.stringify(param))
};

//迪迦添加停复机
export const stopOrOpen = param => {
	return request.post('/api/dxt/stopOrOpen', qs.stringify(param))
};

//长城添加停复机
export const stopOrOpencc = param => {
	return request.post('/api/cc/stopOrOpen', qs.stringify(param))
};


//迪迦限制激活记录
export const activateRecord = param => {
	return request.post('/api/dxt/activateRecord', qs.stringify(param))
};
//迪迦添加限制激活
export const getactivate = param => {
	return request.post('/api/dxt/activate', qs.stringify(param))
};

//迪迦添加文件限制激活
export const getbatchActivate = param => {
	return request.post('/api/dxt/batchActivate', qs.stringify(param))
};


//迪迦激活记录下载
export const downloadActivateRecord = param => {
	return request.post('/api/dxt/downloadActivateRecord', qs.stringify(param), {
		responseType: 'blob'
	})
};


//迪迦停复机下载
export const downloadStopOrOpenRecord = param => {
	return request.post('/api/dxt/downloadStopOrOpenRecord', qs.stringify(param), {
		responseType: 'blob'
	})
};

//长城停复机下载
export const downloadStopOrOpenRecordcc = param => {
	return request.post('/api/cc/downloadStopOrOpenRecord', qs.stringify(param), {
		responseType: 'blob'
	})
};

//迪迦资金池添加金额
export const fundPoolAdd = param => {
	return request.post('/api/dxt/fundPoolAdd', qs.stringify(param))
};

//迪迦资金池记录
export const fundPool = param => {
	return request.post('/api/dxt/fundPool', qs.stringify(param))
};
//迪迦取消停机保号
export const cancelProtection = param => {
	return request.post('/api/dxt/cancelProtection', qs.stringify(param))
};
//迪迦取消停机保号列表
export const cancelProtectionList = param => {
	return request.post('/api/dxt/cancelProtectionList', qs.stringify(param))
};

//迪迦单个充值列表
export const topUpRecord = param => {
	return request.post('/api/dxt/topUpRecord', qs.stringify(param))
};

//迪迦单个充值列表下载
export const topUpRecordDownload = param => {
	return request.post('/api/dxt/topUpRecordDownload', qs.stringify(param))
};
//迪迦添加单个充值
export const AddtopUp = param => {
	return request.post('/api/dxt/topUp', qs.stringify(param))
};
//迪迦异常充值
export const AbnormalTopUp = param => {
	return request.post('/api/dxt/abnormalTopUp', qs.stringify(param))
};
//迪迦批量充值列表
export const batchTopUpRecord = param => {
	return request.post('/api/dxt/batchTopUpRecord', qs.stringify(param))
};
//迪迦APP充值开启
export const stopDxtApp = param => {
	return request.post('/api/topUp/stopDxtApp', qs.stringify(param))
};

//查询是否开启app迪迦充值
export const dxtEnabled = param => {
	return request.post('/api/topUp/dxtEnabled', qs.stringify(param))
};
//迪加复机设置
export const dxtRecordingRecover = param => {
	return request.post('/api/dxt/RecordingRecover', qs.stringify(param))
};

//长城复机设置
export const dxtRecordingRecovercc = param => {
	return request.post('/api/cc/RecordingRecover', qs.stringify(param))
};

//迪迦话单异常列表
export const dxtErrRecord = param => {
	return request.post('/api/dxt/dxtErrRecord', qs.stringify(param))
};
//迪迦返销
export const ReturnPremium = param => {
	return request.post('/api/dxt/ReturnPremium', qs.stringify(param))
};

//迪迦返销记录
export const ReturnPremiumRecord = param => {
	return request.post('/api/dxt/ReturnPremiumRecord', qs.stringify(param))
};

//迪迦冻结
export const frozen = param => {
	return request.post('/api/dxt/frozen', qs.stringify(param))
};
//迪迦冻结
export const frozenRecord = param => {
	return request.post('/api/dxt/frozenRecord', qs.stringify(param))
};
//迪迦开户信息查询
export const auditResult = param => {
	return request.post('/api/dxt/auditResult  ', qs.stringify(param))
};

//蜗牛添加停复机
export const SnailStopOrOpen = param => {
	return request.post('/api/Snail/stopOrOpen', qs.stringify(param))
};


//Cy蜗牛添加停复机
export const CySnailStopOrOpen = param => {
	return request.post('/api/SnailCy/stopOrOpen', qs.stringify(param))
};




//蜗牛停复机记录
export const stopOrOpenRecordList = param => {
	return request.post('/api/Snail/stopOrOpenRecord', qs.stringify(param))
};

//Cy蜗牛停复机记录
export const CystopOrOpenRecordList = param => {
	return request.post('/api/SnailCy/stopOrOpenRecord', qs.stringify(param))
};

//蜗牛停复机下载
export const WNdownloadStopOrOpenRecord = param => {
	return request.post('/api/Snail/downloadStopOrOpenRecord', qs.stringify(param), {
		responseType: 'blob'
	})
};
//Cy蜗牛停复机下载
export const CyWNdownloadStopOrOpenRecord = param => {
	return request.post('/api/SnailCy/downloadStopOrOpenRecord', qs.stringify(param), {
		responseType: 'blob'
	})
};

//长城话单异常列表
export const ccSnailErrRecord = param => {
	return request.post('/api/cc/ErrRecord', qs.stringify(param))
};
//蜗牛话单异常列表
export const SnailErrRecord = param => {
	return request.post('/api/Snail/ErrRecord', qs.stringify(param))
};
//Cy蜗牛话单异常列表
export const CySnailErrRecord = param => {
	return request.post('/api/SnailCy/ErrRecord', qs.stringify(param))
};

//蜗牛批量加白手动
export const BatchWhitening = param => {
	return request.post('/api/Snail/BatchWhitening', qs.stringify(param))
};


//Cy蜗牛批量加白手动
export const CyBatchWhitening = param => {
	return request.post('/api/SnailCy/BatchWhitening', qs.stringify(param))
};


//蜗牛加白记录
export const getContrastInfo = data => {
	return request.get('/api/Snail/getContrastInfo?importFileName=' + data.importFileName +
		'&&pageIndex=' + data.pageIndex + '&&pageSize=' + data.pageSize)

};

//Cy蜗牛加白记录
export const CygetContrastInfo = data => {
	return request.get('/api/SnailCy/getContrastInfo?importFileName=' + data.importFileName +
		'&&pageIndex=' + data.pageIndex + '&&pageSize=' + data.pageSize)

};

//蜗牛充值
export const snailTopUp = param => {
	return request.post('/api/Snail/topUp', qs.stringify(param))
};
//蜗牛充值列表
export const snailShowRemittanceInfo = param => {
	return request.post('/api/Snail/showRemittanceInfo', qs.stringify(param))
};

//蜗牛回退
export const snailBatchDeduction = param => {
	return request.post('/api/Snail/BatchDeduction', qs.stringify(param))
};
//蜗牛回退记录
export const snailTopUpRecord = param => {
	return request.post('/api/Snail/TopUpRecord', qs.stringify(param))
};
//蜗牛限制返档
export const reverseFile = param => {
	return request.post('/api/Snail/ReverseFile', qs.stringify(param))
};
//Cy蜗牛限制返档
export const CyreverseFile = param => {
	return request.post('/api/SnailCy/ReverseFile', qs.stringify(param))
};
//蜗牛开户进度
export const openAcctSchedule = param => {
	return request.post('/api/Snail/openAcctSchedule', qs.stringify(param))
};
//Cy蜗牛开户进度
export const CyopenAcctSchedule = param => {
	return request.post('/api/SnailCy/openAcctSchedule', qs.stringify(param))
};
//蜗牛商户余额
export const queryDeptBalance = data => {
	return request.get('/api/Snail/queryDeptBalance')
};
//迪加套餐
export const getDxtPackage = data => {
	return request.get('/api/dxt/getDxtPackage')
};

//迪加套餐修改
export const updateDxtPackage = param => {
	return request.post('/api/dxt/updateDxtPackage', qs.stringify(param))
};
//Cy蜗牛复机设置
export const CyRecordingRecover = param => {
	return request.post('/api/SnailCy/RecordingRecover', qs.stringify(param))
};


//蜗牛复机设置
export const RecordingRecover = param => {
	return request.post('/api/Snail/RecordingRecover', qs.stringify(param))
};

//迪加停机保号设置
export const updateCancellation = param => {
	return request.post('/api/dxt/updateCancellation', qs.stringify(param))
};
//迪加停机保号查询
export const getCancellation = userId => {
	return request.get('/api/dxt/getCancellation?userId=' + userId)
};
//迪加停复机下载
export const fastdfsfile = param => {
	return request.post('/api/Snail/fastdfsfile', qs.stringify(param), {
		responseType: 'blob'
	})
};
//Cy蜗牛停复机下载
export const Cyfastdfsfile = param => {
	return request.post('/api/SnailCy/fastdfsfile', qs.stringify(param), {
		responseType: 'blob'
	})
};
export const fastdfsfile2 = param => {
	return request.post('/api/Snail/fastdfsfile', qs.stringify(param))
};
//蜗牛批量销户
export const fastdfsfile3 = param => {
	return request.post('/api/Snail/fastdfsfile', qs.stringify(param))
};
//Cy蜗牛批量销户记录列表
export const CygetBatchCancellation = data => {
	return request.get('/api/SnailCy/getBatchCancellation?importFileName=' + data.importFileName +
		'&&pageIndex=' + data.pageIndex + '&&pageSize=' + data.pageSize + '&&userId=' + data.userId)
};
//蜗牛批量销户记录列表
export const getBatchCancellation = data => {
	return request.get('/api/Snail/getBatchCancellation?importFileName=' + data.importFileName +
		'&&pageIndex=' + data.pageIndex + '&&pageSize=' + data.pageSize + '&&userId=' + data.userId)
};
//蜗牛批量销户
export const batchCancellation = param => {
	return request.post('/api/Snail/batchCancellation', qs.stringify(param))
};

//Cy蜗牛批量销户
export const CybatchCancellation = param => {
	return request.post('/api/SnailCy/batchCancellation', qs.stringify(param))
};


//模版列表查询
export const findCrmTemplate = param => {
	return request.post('/api/customize/findCrmTemplate', qs.stringify(param))
};
//蜗牛APP充值开启
export const stopWNApp = param => {
	return request.post('/api/topUp/stop', qs.stringify(param))
};
//查询是否开启app迪迦充值
export const WNEnabled = param => {
	return request.post('/api/topUp/enabled', qs.stringify(param))
};
//删除crm模板
export const deleteCrmTemplate = param => {
	return request.post('/api/customize/deleteCrmTemplate', qs.stringify(param))
};
//应用crm模板
export const useCrmTemplates = param => {
	return request.post('/api/customize/useCrmTemplates', qs.stringify(param))
};
//添加crm模板
export const addCrmTemplate = param => {
	return request.post('/api/customize/addCrmTemplate', param, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
};
//迪加呼叫限频删除
export const deleteBatch = param => {
	return request.post('/api/dxt/deleteLimitCall', qs.stringify(param))
};
//迪加 冻结自选套餐  导出
export const frozenRecordDownload = param => {
	return request.post('/api/dxt/frozenRecordDownload', qs.stringify(param), {
		responseType: 'blob'
	})
};
//迪加呼叫限频次数设置
export const AddFrequencyLimit = param => {
	return request.post('/api/dxt/addLimitCall', qs.stringify(param))
};

//迪加呼叫限频列表
export const deptParam = param => {
	return request.post('/api/dxt/getLimitCall', qs.stringify(param))
};

//虚商 企业限频添加设置
export const companyLimitAdd = param => {
	return request.post('/api/companyLimit/add', param, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
};
//虚商 企业限频
export const getCompanyLimit = param => {
	return request.get('/api/companyLimit/findAll?pageIndex=' + param.pageIndex + '&&pageSize=' + param.pageSize +
		'&&agentId=' + param.agentId + '&&companyId=' + param.companyId + '&&cardsId=' + param.cardsId)
};
//虚商 企业限频记录
export const getCompanyLimitRecord = param => {
	return request.get('/api/companyLimit/record?pageIndex=' + param.pageIndex + '&&pageSize=' + param.pageSize +
		'&&agentId=' + param.agentId + '&&companyId=' + param.companyId + '&&cardsId=' + param.cardsId +
		'&&phone=' + param.phone)
};

export const getDxtPackagesOfNumber = () => {
	return request.get('/api/dxt/packages/list')
};

export const getDxtPackagesOfNumberById = id => {
	return request.get('/api/dxt/packages/detail?id=' + id)
};

export const getDxtPackagesOfNumberByName = packagesName => {
	return request.get('/api/dxt/packages/detailByName?packagesName=' + packagesName)
};

export const addDxtPackagesOfNumber = param => {
	return request.post('/api/dxt/packages/add', qs.stringify(param))
};

export const updateDxtPackagesOfNumber = param => {
	return request.post('/api/dxt/packages/update', qs.stringify(param))
};

export const deleteDxtPackagesOfNumber = id => {
	return request.post('/api/dxt/packages/delete', qs.stringify({ id }))
};

export const packageTopUp = param => {
	return request.post('/api/dxt/packageTopUp/topUp', qs.stringify(param))
};

export const getPackageTopUpRecord = param => {
	return request.get('/api/dxt/packageTopUp/list?phone=' + (param.phone || '') +
		'&fileBatchNo=' + (param.fileBatchNo || '') +
		'&status=' + (param.status !== null && param.status !== undefined ? param.status : '') +
		'&refundStatus=' + (param.refundStatus !== null && param.refundStatus !== undefined ? param.refundStatus : '') +
		'&agentId=' + (param.agentId || '') +
		'&companyId=' + (param.companyId || '') +
		'&packagesName=' + (param.packagesName || '') +
		'&pageIndex=' + param.pageIndex +
		'&pageSize=' + param.pageSize)
};

export const processPackageTopUp = ids => {
	return request.post('/api/dxt/packageTopUp/process', qs.stringify({ ids }))
};

// 迪加套餐充值返销
export const refundPackageTopUp = param => {
	return request.post('/api/dxt/packageTopUp/refund', qs.stringify(param))
};

// 迪加套餐批量查询
export const batchPhoneInfo = param => {
	return request.post('/api/dxt/packageTopUp/batchPhoneInfo', param, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
};

// 迪加套餐批量充值
export const batchTopUp = param => {
	return request.post('/api/dxt/packageTopUp/batchTopUp', param, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
};

// 迪加套餐文件充值预览
export const fileRechargePreview = param => {
	return request.post('/api/dxt/packageTopUp/fileRechargePreview', param, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
};

// 迪加套餐文件充值确认
export const fileRechargeConfirm = param => {
	return request.post('/api/dxt/packageTopUp/fileRechargeConfirm', param, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
};

// 迪加套餐下载模板
export const downloadTemplate = () => {
	return request.get('/api/dxt/packageTopUp/downloadTemplate', {
		responseType: 'blob'
	})
};

// 迪加套餐次月到账 - 预览待处理订单
export const previewNextMonthArrival = () => {
	return request.get('/api/dxt/packageTopUp/previewNextMonthArrival')
};

// 迪加套餐次月到账人工处理 - 测试版本（仅日志）
export const processNextMonthArrivalTest = param => {
	return request.post('/api/dxt/packageTopUp/processNextMonthArrivalTest', qs.stringify(param))
};

// 迪加套餐次月到账人工处理 - 正式版本（执行实际操作）
export const processNextMonthArrivalFormal = param => {
	return request.post('/api/dxt/packageTopUp/processNextMonthArrivalFormal', param, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
};

// 查询充值操作日志
export const getTopUpLogs = param => {
  return request.get('/api/dxt/packageTopUp/getTopUpLogs', { params: param })
};

export const getAccountStatistics = (startYearMonth, endYearMonth, packagesName, agentId, companyId) => {
  return request.get('/api/dxt/packageTopUp/accountStatistics', {
    params: {
      startYearMonth,
      endYearMonth,
      packagesName,
      agentId,
      companyId
    }
  })
};

// 账务统计导出
export const exportAccountStatistics = (startYearMonth, endYearMonth, packagesName, agentId, companyId) => {
  return request.get('/api/dxt/packageTopUp/accountStatistics/export', {
    params: {
      startYearMonth,
      endYearMonth,
      packagesName,
      agentId,
      companyId
    },
    responseType: 'blob'
  })
};

// 查询代理下有账务记录的企业
export const getCompaniesWithRecords = (agentId) => {
  return request.get('/api/dxt/packageTopUp/companiesWithRecords', {
    params: {
      agentId
    }
  })
};
